import type { ReactNode } from "react";
import styles from "./TouchTarget.module.css";

/**
 * Expand the hit area to at least 44×44px on touch devices
 */
export function TouchTarget({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
      <span aria-hidden="true" className={styles.TouchTarget} />
    </>
  );
}
